import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge, RepostedBadge } from "./styles";
import { useTranslation } from "react-i18next";
import { Project } from "@brg/api";
import { isProjectRepostedOnShowcase } from "shared/helpers/projectStatus";
import { useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { OrganizationsSelector } from "shared/reducers/OrganizationsSlice";

export const ProjectBadge: FC<{ project: Project }> = ({ project }) => {
    const { t , i18n: { language }} = useTranslation();
    const isShowcase = !!useRouteMatch('/teams/:id');
    const {team: currentTeam } = useSelector(OrganizationsSelector)

    if (isProjectRepostedOnShowcase(currentTeam, project) && isShowcase) {
        return <RepostedBadge>{t('panel.statuses.reposted')}</RepostedBadge>
    }



    return null
}import { FC } from "react";
import { DRAFT_TEAM_STATUS, HIDDEN_TEAM_STATUS, REJECTED_TEAM_STATUS, UNDER_APPROVAL_TEAM_STATUS } from "shared/helpers/teamsStatus";
import { DraftBadge, HiddenBadge, ModerationBadge, RejectedBadge, RepostedBadge } from "./styles";
import { useTranslation } from "react-i18next";
import { Project } from "@brg/api";
import { isProjectRepostedOnShowcase } from "shared/helpers/projectStatus";
import { useRouteMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import { OrganizationsSelector } from "shared/reducers/OrganizationsSlice";

export const ProjectBadge: FC<{ project: Project }> = ({ project }) => {
    const { t , i18n: { language }} = useTranslation();
    const isShowcase = !!useRouteMatch('/teams/:id');
    const {team: currentTeam } = useSelector(OrganizationsSelector)

    if (isProjectRepostedOnShowcase(currentTeam, project) && isShowcase) {
        return <RepostedBadge>{t('panel.statuses.reposted')}</RepostedBadge>
    }



    return null
}